(ns app.front.view.fee.events
  (:require [app.front.process :as process]
            [app.front.util :as futil]
            [re-frame.core-instrumented :as rf]))

(rf/reg-fx ::submit-payment-form
  (fn [form-html]
    (let [elem (.createElement js/document "div")]
      (-> js/document .-body (.appendChild elem))
      (set! (.-innerHTML elem) form-html)
      (-> elem .-firstChild .submit))))

(rf/reg-event-fx ::add-bill-and-scroll
  (fn [_ [_ process-target signal]]
    {:fx [[:dispatch [::process/signal process-target signal]]
          [::futil/scroll-to-section "application-fees-and-payments"]]}))
